import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'components';
import * as styles from './SocialMediaSummary.scss';
var NextStepsPreview = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NextStepsPreview, _Component);

  var _super = _createSuper(NextStepsPreview);

  function NextStepsPreview() {
    _classCallCheck(this, NextStepsPreview);

    return _super.apply(this, arguments);
  }

  _createClass(NextStepsPreview, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          items = _this$props.items,
          section = _this$props.section,
          selectedClient = _this$props.selectedClient;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.wrap, " ").concat(styles.itemPageBreak)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.column
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 16
        }
      }, "Here are some content and advertisment suggestions based on recent performance."), /*#__PURE__*/React.createElement("ul", {
        className: styles.nextStepsInnerList
      }, items && items.length && items.map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          className: styles.nextStepsListItem,
          style: {
            minHeight: 58,
            height: 'auto'
          },
          key: index
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.largeText,
          style: {
            color: _this.props.theme.colors.secondaryColor
          }
        }, item.label), /*#__PURE__*/React.createElement("ul", {
          className: styles.nextStepsInnerList
        }, item.textFields.map(function (textField, index2) {
          return textField !== '' ? /*#__PURE__*/React.createElement("li", {
            className: styles.innerListItem,
            key: "textField".concat(index2)
          }, textField) : null;
        })));
      }))));
    }
  }]);

  return NextStepsPreview;
}(Component)) || _class);
export { NextStepsPreview as default };